import { Button, Checkbox, FormControlLabel, Typography } from "@mui/material";
import NextAction from "../../utils/NextAction";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";

function createData(
  vertex: string,
  dist?: number,
  visited?: boolean,
  previous?: string
) {
  return { vertex, dist, visited: visited, previous };
}

const rows = [
  [
    createData("A", null, false, null),
    createData("B", null, false, null),
    createData("C", null, false, null),
    createData("D", null, false, null),
    createData("E", null, false, null),
    createData("F", null, false, null),
    createData("G", null, false, null),
    createData("H", null, false, null),
    createData("I", null, false, null),
    createData("J", null, false, null),
  ],
  [
    createData("A", 0, false, null),
    createData("B", null, false, null),
    createData("C", null, false, null),
    createData("D", null, false, null),
    createData("E", null, false, null),
    createData("F", null, false, null),
    createData("G", null, false, null),
    createData("H", null, false, null),
    createData("I", null, false, null),
    createData("J", null, false, null),
  ],
  [
    createData("A", 0, true, null),
    createData("B", null, false, null),
    createData("C", 1, false, "A"),
    createData("D", null, false, null),
    createData("E", null, false, null),
    createData("F", null, false, null),
    createData("G", null, false, null),
    createData("H", null, false, null),
    createData("I", null, false, null),
    createData("J", null, false, null),
  ],
  [
    createData("A", 0, true, null),
    createData("B", null, false, null),
    createData("C", 1, true, "A"),
    createData("D", 2, false, "C"),
    createData("E", null, false, null),
    createData("F", null, false, null),
    createData("G", null, false, null),
    createData("H", null, false, null),
    createData("I", null, false, null),
    createData("J", null, false, null),
  ],
  [
    createData("A", 0, true, null),
    createData("B", null, false, null),
    createData("C", 1, true, "A"),
    createData("D", 2, false, "C"),
    createData("E", null, false, null),
    createData("F", null, false, null),
    createData("G", 2, false, "C"),
    createData("H", null, false, null),
    createData("I", null, false, null),
    createData("J", null, false, null),
  ],
  [
    createData("A", 0, true, null),
    createData("B", null, false, null),
    createData("C", 1, true, "A"),
    createData("D", 2, true, "C"),
    createData("E", 3, false, "D"),
    createData("F", null, false, null),
    createData("G", 2, false, "C"),
    createData("H", null, false, null),
    createData("I", null, false, null),
    createData("J", null, false, null),
  ],
  [
    createData("A", 0, true, null),
    createData("B", null, false, null),
    createData("C", 1, true, "A"),
    createData("D", 2, true, "C"),
    createData("E", 3, false, "D"),
    createData("F", null, false, null),
    createData("G", 2, true, "C"),
    createData("H", null, false, null),
    createData("I", 3, false, "G"),
    createData("J", null, false, null),
  ],
  [
    createData("A", 0, true, null),
    createData("B", null, false, null),
    createData("C", 1, true, "A"),
    createData("D", 2, true, "C"),
    createData("E", 3, true, "D"),
    createData("F", 4, false, "E"),
    createData("G", 2, true, "C"),
    createData("H", null, false, null),
    createData("I", 3, false, "G"),
    createData("J", null, false, null),
  ],
  [
    createData("A", 0, true, null),
    createData("B", null, false, null),
    createData("C", 1, true, "A"),
    createData("D", 2, true, "C"),
    createData("E", 3, true, "D"),
    createData("F", 4, false, "E"),
    createData("G", 2, true, "C"),
    createData("H", null, false, null),
    createData("I", 3, true, "G"),
    createData("J", 4, false, "I"),
  ],
  [
    createData("A", 0, true, null),
    createData("B", 5, false, "F"),
    createData("C", 1, true, "A"),
    createData("D", 2, true, "C"),
    createData("E", 3, true, "D"),
    createData("F", 4, true, "E"),
    createData("G", 2, true, "C"),
    createData("H", null, false, null),
    createData("I", 3, true, "G"),
    createData("J", 4, false, "I"),
  ],
  [
    createData("A", 0, true, null),
    createData("B", 5, false, "F"),
    createData("C", 1, true, "A"),
    createData("D", 2, true, "C"),
    createData("E", 3, true, "D"),
    createData("F", 4, true, "E"),
    createData("G", 2, true, "C"),
    createData("H", 5, false, "F"),
    createData("I", 3, true, "G"),
    createData("J", 4, false, "I"),
  ],
  [
    createData("A", 0, true, null),
    createData("B", 5, false, "F"),
    createData("C", 1, true, "A"),
    createData("D", 2, true, "C"),
    createData("E", 3, true, "D"),
    createData("F", 4, true, "E"),
    createData("G", 2, true, "C"),
    createData("H", 5, false, "F"),
    createData("I", 3, true, "G"),
    createData("J", 4, true, "I"),
  ],
  [
    createData("A", 0, true, null),
    createData("B", 5, true, "F"),
    createData("C", 1, true, "A"),
    createData("D", 2, true, "C"),
    createData("E", 3, true, "D"),
    createData("F", 4, true, "E"),
    createData("G", 2, true, "C"),
    createData("H", 5, false, "F"),
    createData("I", 3, true, "G"),
    createData("J", 4, true, "I"),
  ],
  [
    createData("A", 0, true, null),
    createData("B", 5, true, "F"),
    createData("C", 1, true, "A"),
    createData("D", 2, true, "C"),
    createData("E", 3, true, "D"),
    createData("F", 4, true, "E"),
    createData("G", 2, true, "C"),
    createData("H", 5, true, "F"),
    createData("I", 3, true, "G"),
    createData("J", 4, true, "I"),
  ],
];

const texts = [
  `
  Click the below button "Start Tutorial" to see step by step of Dijkstra's Algorithm for Grids.
  `,
  "We know the distance between A and A is 0, so we can update the distance value in the table accordingly.",
  "Let's check the A node and mark 'Visited' as True. First, we update the distance between A and C. We know the distance between these two nodes is 1, so we replace infinity with 1 and label 'A' in the 'Previous Node' column.",
  "After finishing the process of checking A, we start to trace another node. We find the shortest path on the table first, which is A -> C. We label C as True in the Visited column. Because the distance between C and D is 1, we also update the shortest distance between A and D to 2.",
  "Check the distance from C to G. Update the shortest distance from A to G to 2 and label the previous node of G as C.",
  "Next, because the distances between A and D and A and G are both 2, we can choose either one of them. We choose D first in alphabetical order. We label D as True in the Visited column. The only neighbors of D is E. The distance between D and E is 1, so we update the shortest distance to E to 2 + 1 = 3.",
  "Then, we check G and its neighboor I. We label G as True in the Visited column. The new shortest distance from A to I is 3.",
  "Because the distances between A and E and A and I are both 3, we can choose either one of them. We choose E first in alphabetical order. We label E as True in the Visited column. The only neighbors of E is F. We update the shortest distance to F to 3 + 1 = 4.",
  "Then, we check I and its neighboor J. We label I as True in the Visited column. The new shortest distance from A to J is 4.",
  "Next, because the distances between A and F and A and J are both 4, we can choose either one of them. We choose F first in alphabetical order. We label F as True in the Visited column. There are two neighboors: B and H. We choose B first in alphabetical order. We update the shortest distance to B to 4 + 1 = 5.",
  "Then, we check H. The new shortest distance from A to H is 5.",
  "Next, we check J. We label J as True in the Visited column. There is no neighboor of J, so no distance update on the table.",
  "Next, we check B. We label B as True in the Visited column. There is no neighboor of B, so no distance update on the table.",
  `Finally, we check H. We label H as True in the Visited column. There is no neighboor of H, so no distance update on the table.
  We now get the shortest from A to H which is 5!
  `,
];

interface ContrlProps {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

export default function Controls({ step, setStep }: ContrlProps) {
  return (
    <div className="controls">
      <div>
        <Typography variant="h5" style={{ paddingBottom: 20 }}>
          Dijkstra's Algorithm For Grids
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          On this page, we will introduce how to implement Dijkstra's Algorithm
          on a grid map. Why use a grid map? Because most maps are not
          constructed as graphs, it is difficult to use graph-based
          methodologies to find paths on real-world maps. However, it is easy to
          convert a map into a grid. If we can apply Dijkstra's Algorithm on a
          grid, we can apply it to all real-world maps. <br />
          <br />
          Let's look at the gird on the right side.{" "}
          <b style={{ color: "gray" }}>Gray</b> blocks represent obstacles that
          cannot be traversed. White blocks are the empty paths we can move
          through. <b style={{ color: "orange" }}>Orange</b> block is the
          starting point and the <b style={{ color: "green" }}>Green</b> block
          is the target. <b style={{ color: "#35baf6" }}>Blue</b> blocks
          indicate visited nodes. We can treat the available blocks as nodes on
          a graph, with the connections between blocks representing edges with a
          length of 1. Using this method, we can convert the grid into a graph
          data structure and apply Dijkstra's Algorithm to it. The terms used in
          the table are the same as those on the{" "}
          <Link to="/dijkstras">previous Dijkstra's Algorithm page</Link>.
        </Typography>
        {step == 0 && (
          <Typography
            style={{
              paddingBottom: 10,
              textAlign: "left",
              whiteSpace: "pre-line",
            }}
          >
            {texts[step]}
          </Typography>
        )}
        {step != 0 && (
          <>
            <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
              Step {step}
            </Typography>
            <Typography
              sx={{ mb: 3, textAlign: "left", whiteSpace: "pre-line" }}
            >
              {texts[step]}
            </Typography>
          </>
        )}
        <TableContainer
          component={Paper}
          sx={{ mb: 2, maxWidth: 600, mr: "auto", ml: "auto" }}
        >
          <Table sx={{ maxWidth: 600 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Vertex</TableCell>
                <TableCell align="right">Shortest Distance From A</TableCell>
                <TableCell align="right">Visited</TableCell>
                <TableCell align="right">Previous Node</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows[step].map((row, i) => (
                <TableRow
                  key={row.vertex}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row" sx={{ fontSize: 18 }}>
                    {row.vertex}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={
                      step !== 0 && row.dist != rows[step - 1][i].dist
                        ? { color: "red", fontWeight: "bold", fontSize: 18 }
                        : { fontSize: 18 }
                    }
                  >
                    {row.dist == null ? "infinity" : row.dist}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={
                      step !== 0 && row.visited != rows[step - 1][i].visited
                        ? { color: "red", fontWeight: "bold", fontSize: 18 }
                        : { fontSize: 18 }
                    }
                  >
                    {row.visited ? "True" : "False"}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={
                      step !== 0 && row.previous != rows[step - 1][i].previous
                        ? { color: "red", fontWeight: "bold", fontSize: 18 }
                        : { fontSize: 18 }
                    }
                  >
                    {row.previous || "null"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {step == 0 && (
          <Button
            variant={"contained"}
            sx={{ mb: 2 }}
            onClick={() => setStep(1)}
          >
            Start Tutorial
          </Button>
        )}
        {step != 0 && (
          <>
            <Button
              variant={"contained"}
              sx={{ mb: 2, mr: 4 }}
              onClick={() => setStep(step - 1)}
            >
              Previous
            </Button>
            {step !== 13 && (
              <Button
                variant={"contained"}
                sx={{ mb: 2 }}
                onClick={() => setStep(step + 1)}
              >
                Next
              </Button>
            )}
          </>
        )}
        {step == 13 && (
          <>
            <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
              Great job! You now understand Dijkstra's Algorithm for grids.
              <br />
              If you observe carefully, you'll notice that Dijkstra's Algorithm{" "}
              <b>visit all nodes to compute the shortest path.</b> However, if
              you already have a specific target node in mind, this algorithm
              might seem{" "}
              <b>overdesigned and can consume a lot of computing time.</b> The
              A* Algorithm addresses this issue, and we will introduce it next.
              Let's go!
            </Typography>
            <NextAction
              label={"Next: A* Algorithm for Grids"}
              to="/robotics/astar-for-grids"
            />
          </>
        )}
      </div>
    </div>
  );
}
